import {hitGoogleTagManager} from "./hit_google_tag_manager";

export type EventTypeWeWillFindForYou = "find_for_open" | "find_for_interaction" | "find_for_sent" | "find_for_close" | "find_for_back";

interface IGtmWeWillFindForYouBase {
    event: EventTypeWeWillFindForYou;
}

/**
 * When clicking the button that opens the modal
 */
export const gtmWeWillFindForYouOpen = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_open"
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export type EventTypeWeWillFindForYou = "find_for_open" | "find_for_interaction" | "find_for_sent" | "find_for_close" | "find_for_back";

interface IGtmWeWillFindForYouBase {
    event: EventTypeWeWillFindForYou;
}

/**
 * When clicking the button that opens the modal
 */
export const gtmWeWillFindForYouOpen = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_open"
    };

    hitGoogleTagManager(gtmData);
};
